/*
 * @Author: Fu Zhuohang
 * @Date: 2022-01-04 18:06:33
 * @LastEditors: Fu Zhuohang
 * @LastEditTime: 2022-02-23 10:55:08
 * @FilePath: \yunshu6.0\modules\@cloudpivot\application\src\components\pc\locales\en-US.ts
 * @Description:
 */
export default {
    inputAppName: 'Please input App Name',
    noResult: 'There\'s no result with "{keyword}"',
    cancelCollection: 'Cancel collection',
    addToCollection: 'Add to collection',
    moreData: 'More',
    owningApplication: 'Application',
    allApplications: 'All applications',
    searchBox: {
        inputSearch: 'Enter search content',
        search: 'Search',
        all: 'All',
        application: 'Application',
        model: 'Model',
        workflow: 'Workflow',
        notification: 'Notification',
        toDoTask: '【Workflow】To-do Task',
        total: 'Total ',
        results: '',
        more: 'More',
        owningApplication: 'Application: ',
        noSearchResult: 'No search results yet',
        searching: 'Searching',
        Notifications: 'Notifications',
        AltAndReply: '@ & Reply',
    },
    notificationItem: {
        you1: 'you',
        checkDetail: 'Detail',
    },
    SearchFormName: 'Search sheet name',
    SearchResult: 'result ',
    QueryTips2: 'items',
};
